import { render, staticRenderFns } from "./JsonViewerDialog.vue?vue&type=template&id=2ca701e7&scoped=true"
import script from "./JsonViewerDialog.vue?vue&type=script&lang=js"
export * from "./JsonViewerDialog.vue?vue&type=script&lang=js"
import style0 from "./JsonViewerDialog.vue?vue&type=style&index=0&id=2ca701e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca701e7",
  null
  
)

export default component.exports